import { AgreementViewContainer } from 'src/containers/SoftwareEscrow/Agreement';

const SettingsAgreement = () => {
  return <AgreementViewContainer />;
};

export default SettingsAgreement;
